<template>
	<div style="padding: 10px;">
		<el-row :gutter="20">
			<el-col :span="4"> 
				<el-select style="width: 100%;" filterable clearable  v-model="searchInfo.id" placeholder="请选择校区">
					<el-option v-for="item in orgList" :key="item.id" :label="item.name" :value="item.id"> </el-option>
				</el-select>
			</el-col>
			<el-col :span="7">
				<el-date-picker style="width: 100%;" v-model="searchInfo.timerange" type="daterange" format="yyyy-MM-dd"
					range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" @change="timeRangeChange">
				</el-date-picker>
			</el-col>
			<el-col :span="12"> 
				<div style="min-width: 300px;">
					<el-button type="primary" @click="searchAirTimes" icon="el-icon-search">搜索</el-button>
					<!-- <el-button  icon="el-icon-refresh" @click="clearSearch">重置</el-button> -->
					<el-button @click="exportFile" icon="el-icon-download">导出</el-button>
					<!-- <el-button >
						<el-link icon="el-icon-download" :href="baseUrl+prefix+'api/report/orgAirTimesExport?oid='+searchInfo.id+'&begin='+searchInfo.begin+'&end='+searchInfo.end">导出</el-link>
					</el-button> -->
				</div>
			</el-col>
		</el-row>
		<div style="margin-top: 10px;">
			<div style="max-height: 740px;overflow: auto;">
				<el-row style="padding-top: 5px;padding-bottom: 5px;border-bottom: 1px solid #dcdfe6;" justify="center" align="middle" v-for="(room,ridx) in schoolAirTimeList" :key="room.id">
					<el-col :span="3">
						{{room.name}}
					</el-col>
					<el-col :span="21">
						<el-row justify="center" align="center" v-for="(air,idx) in room.airsttimes" :key="air.id"
							:style="{borderBottom: idx < (room.airsttimes.length-1) ? '1px solid #dcdfe6' : 'none',
							paddingTop: idx > 0 ? '5px' : '0px', paddingBottom: idx == (room.airsttimes.length-1) ? '0px' : '5px'}">
							<el-col :span="2">
								{{air.name}}
							</el-col>
							<el-col :span="22">
								<div v-for="(st,sidx) in air.states" :key="sidx">
									<div v-for="(stday,sdidx) in st.rundata" :key="sdidx" 
										style="width: 130px;float: left;padding: 10px;border: #dcdfe6 1px solid;border-radius: 10px;"
										:style="{color : stday.times==0 ? '#909399' : (stday.times > 0 && stday.times <= 4 ? '#303133' : 
											(stday.times > 4 && stday.times <= 8 ? '#67C23A' :
											(stday.times > 8 && stday.times <= 12 ? '#18b566' : 
											(stday.times > 12 && stday.times <= 16 ? '#ff9900' : 
											(stday.times > 16 && stday.times <= 20 ? '#fab6b6' : '#fa3534'))))) }" @click="gotoDetail(ridx,idx,sidx,sdidx)">
										<div style="text-align: center;">{{stday.day}} </div> 
										<div style="margin-top: 10px;text-align: center;">{{st.name}} : {{stday.times}} 小时</div> 
										<!-- <div style="color: gray;margin-top: 10px;font-size: 10px;"> -->
										<div style="margin-top: 10px;font-size: 10px;">
											<div style="text-align: center;" v-for="(val,ii) in stday.flagdatas" :key="ii">
												{{val.flag}}={{val.hours}}小时
											</div>
										</div>
									</div>
								</div>
							</el-col>
						</el-row>
					</el-col>
				</el-row>
			</div>
		</div>
		<!-- <div style="text-align: center;">
			<el-pagination background layout="total, prev, pager, next, sizes" :page-sizes="[10, 20, 50]" :current-page="param.page"
				:page-size="param.pagenum" :total="schoolAirTimeTotal" @size-change="handleSizeChange" @current-change="handleCurrentChange"> </el-pagination>
		</div> -->
		<el-dialog :destroy-on-close="true" :title="detailTitle" width="70%" :visible.sync="detailShow">
			<AirDetail @needRefrash="needRefrash" :roomname="selectedroomname" :airname="selectedairname" :roomid="selectedroomid" :day="selectedday" :num="selectedairnum" ></AirDetail>
		</el-dialog>
	</div>
</template>

<script>
	//import dayjs from 'dayjs'
	import axios from 'axios'
	import { baseUrl, prefix } from '/public/baseUrl.js'
	import { queryAllOrg, querySchoolAirOpens } from '/static/apiUrl.js'
	import AirDetail from './airdetail.vue'
	export default {
		name : 'AirTime',
		data() {
			return {
				detailShow: false,
				editok : false,
				isadd : false,
				detailTitle: '详情',
				selectset: null,	
				searchInfo:{
					name: '',
					id : '',
					timerange : '',
					begin : '',
					end : '',
				},
				orgList : [],
				/* param : {
					page : 1,
					pagenum : 10,
				}, */
				schoolAirTimeTotal : 0,
				schoolAirTimeList : [],
				selectedroomid : '',
				selectedday: '',
				selectedairnum : '',
				selectedroomname : '',
				selectedairname : '',
				
			}
		},
		mounted() {
			this.initData()
			//this.queryAirOpenReports()
		},
		components: {
			AirDetail,
		},
		methods: {
			timeRangeChange(e){
				this.searchInfo.begin = this.$formatDate(e[0],'yyyy-MM-dd')
				this.searchInfo.end = this.$formatDate(e[1],'yyyy-MM-dd')
				//console.log(this.searchInfo)
			},
			/* handleSizeChange(val){
				this.param.pagenum = val;
				this.queryAirOpenReports()
			},
			handleCurrentChange(val){
				this.param.page = val
				this.queryAirOpenReports()
			}, */
			initData() {
				this.orgList = []
				queryAllOrg().then(res => {
					if(0 == res.code){
						res.datas.forEach((org) => {
							if("XQ" == org.type){
								this.orgList.push(org)
							}
						})
					}
				})
			},
			searchAirTimes(){
				//this.param.page = 1
				this.schoolAirTimeList = []
				this.queryAirOpenReports()
			},
			clearSearch(){
				this.searchInfo.name = ''
				this.searchInfo.id = ''
				this.searchInfo.timerange = ''
				//this.param.page = 1
				this.queryAirOpenReports()
			},
			queryAirOpenReports(){
				const loading = this.$loading({
					lock: true,
					text: '加载数据中...',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.7)'
				});
				this.schoolAirTimeList = []
				if(this.searchInfo.id && this.searchInfo.begin && this.searchInfo.end){
					querySchoolAirOpens({
						oid : this.searchInfo.id,
						begin : this.searchInfo.begin,
						end : this.searchInfo.end
					}).then(res => {
						if(0 == res.code){
							//this.schoolAirTimeTotal = res.datas.totalnum
							this.schoolAirTimeList = res.datas
						}
						loading.close();
					}).catch(err => {
						console.log(err)
						loading.close();
						this.$message({
							showClose: true,
							message: "超时",
							type: 'error'
						});
					});
				}else{
					setTimeout(() => {
						loading.close();
					}, 500);
				}
			},
			gotoDetail(ridx,idx,aidx,didx){
				
				this.isadd = false
				//console.log(idx,row)
				this.selectedroomid = this.schoolAirTimeList[ridx].id
				this.selectedroomname = this.schoolAirTimeList[ridx].name
				this.selectedairname = this.schoolAirTimeList[ridx].airsttimes[idx].name
				this.selectedday = this.schoolAirTimeList[ridx].airsttimes[idx].states[aidx].rundata[didx].day
				this.selectedairnum = this.schoolAirTimeList[ridx].airsttimes[idx].id
				//this.selectset = JSON.parse(JSON.stringify(this.schoolAirTimeList[ridx].airsttimes))
				console.log(this.selectedroomid,this.selectedday,this.selectedairnum)
				this.detailTitle = this.selectedroomname+' '+this.selectedairname+' '+ this.selectedday +'开启详情'
				this.detailShow = true
			},
			needRefrash(){
				this.detailShow = false
			},
			exportFile(){
				if(this.searchInfo.id == null || this.searchInfo.id == '' || this.searchInfo.begin == '' || this.searchInfo.end == ''){
					this.$message({
						showClose: true,
						message: "请选择校区和时间",
						type: 'error'
					});
					return
				}
				const loading = this.$loading({
					lock: true,
					text: '下载数据中...',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.7)'
				});
				let filename = ""
				this.orgList.forEach((org) => {
					if(org.id == this.searchInfo.id){
						filename = org.name + this.searchInfo.begin + '~'+this.searchInfo.end+'空调开启时间统计.xlsx'
					}
				})
				let autherheader = sessionStorage.getItem("authToken")
				let citycode = localStorage.getItem("citycode")
				axios.get(baseUrl+prefix+citycode+'/api/report/orgAirTimesExport?oid='+this.searchInfo.id+'&begin='+this.searchInfo.begin+'&end='+this.searchInfo.end, 
				{
					headers: {
						'Content-Type': 'blob',
						Authorization: autherheader
					},
					timeout : 500000,
					responseType : 'blob'
				}).then(response => {
					loading.close();
					const url = window.URL.createObjectURL(new Blob([response.data]),{type:`'application/vnd.ms-excel';chartset=utf-8`});
					const link = document.createElement('a');
					link.href = url;
					link.setAttribute('download', filename);
					document.body.appendChild(link);
					link.click();
					document.body.removeChild(link)
					
				}).catch(err => {
					console.log(err)
					loading.close();
					this.$message({
						showClose: true,
						message: "超时",
						type: 'error'
					});
				});
			}
		},
		beforeDestroy() {
			
		},
	}
</script>

<style scoped>
	
</style>